import React from 'react';

const ErrorSpan = ({ error }) => (
  <span className="error" style={{ display: 'block' ,color:'red', fontSize:'12px', marginTop:'0'}}>
    * {error}
  </span>
);
export default ErrorSpan;